<template>
    <div id="map"></div>
</template>

<script>
export default {
    mounted() {
        if (window.kakao && window.kakao.maps) {
            this.initMap();
        } else {
            const script = document.createElement('script');
            /* global kakao */
            script.onload = () => kakao.maps.load(this.initMap);
            script.src = 'http://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=6b3147e53abafa23a0227d5c4f0e0eb3';
            document.head.appendChild(script);
        }
    },

    methods: {
        initMap() {
            var container = document.getElementById('map');
            var options = {
              center: new kakao.maps.LatLng(33.4423524, 126.5715475),
              level: 3
            };
      
            this.map = new kakao.maps.Map(container, options);


            let kslab_position = new kakao.maps.LatLng(33.4423524, 126.5715475)
            const endMarker = new kakao.maps.Marker({
              map: this.map,
              position: kslab_position,
              title: 'KS LAB'
            })
            endMarker.setMap(this.map)

            this.map.setMapTypeId(kakao.maps.MapTypeId.ROADMAP);
        }
    }
}
</script>

<style>
#map {
    width: 100%;
    height: 100%;
}
</style>